import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import {db} from '@/plugins/firebase.js';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    newcard:false,
    editcard:false,
    newresponse:false,
    newresponsecard:false,
    newquickreplycard:false,
    triggerwindow:false,
    tdata:null,
    activeTriggerIndex:null,
    activeResponseIndex:null,
    activeResponseCardIndex:null,

    currentuser:null,
    bots:null,
    triggerNames:[],
    triggerValues:[],
    newTriggerNames:{},
    triggerVals:[],
    editTrgIndex:null,
    editTrgName:null,
    editTrgValues:[],    
    responseNames:null,
    newResponse:null,
    newResponseCard:{},
    newResponseCardId:null,
    responseCards:null,
    quickreplies:[],
    responseDocId:null,
    botsList:[],
    pagesList:null,
    pageDetails:{},
    selectedPage:null,
    responses:[],
    currentResponseIndex:null,
    responseMenuStatus:false,
    bTemplateNames:[],
    bTemplateindex:null,
    bcastmenuStatus:false,
    bmessageTags:[],
    messengercodeurl:null,
    rules:[],
    ruleMenuStatus:false,
    currentruleindex:null,
    assets:[],
    snackbar:{"status":false, "update":null},
    cardEditor:{"index":null, "card":null,"docid":null},
    pageusers:[],
    uservars:[],
    elements:[
      { "active":false,"title":null,"subtitle":null,"file":null,"image_url":"https://cdn.vuetifyjs.com/images/lists/ali.png","default_action": {
            "type": "web_url",
            "url": null,
            "webview_height_ratio": "tall",
          },
        "buttons":[
        {"label":"First Button","active":false,"title":null,"type":null,"url":null,"webview_height_ratio":"tall","payload":null,"response":null},
        {"label":"Second Button","active":false,"title":null,"type":null,"url":null,"webview_height_ratio":"tall","payload":null,"response":null},
        {"label":"Third Button","active":false,"title":null,"type":null,"url":null,"webview_height_ratio":"tall","payload":null,"response":null}
        ]
      }
    ],
    google_sheets:{"status":"noAccess"},
    send_grid:{"status":"noAccess"},
    unknown_keywords:[],
    commentRules:[]
  },
  mutations: {
     newcardwstatus:state=>{
       state.newcard = !state.newcard
     },
     editcardwstatus(state,index){
       if(state.editcard == false){
         state.editTrgIndex = index
         state.editTrgName = state.triggerNames[index].name
         state.editTrgValues = state.triggerValues
         state.editcard = true        
       }
       else{
        state.editcard = false
        state.editTrgIndex = null        
       }
    },
      mnewResponseWindowStatus(state,windowStatus){
      state.newresponse = windowStatus
     },
     mnewResponseCardWindowStatus(state,windowStatus){
     state.newresponsecard = windowStatus
     },
     newquickreplycardwstatus:state=>{
     state.newquickreplycard = !state.newquickreplycard
     },
     triggerwindowstatus:state=>{
     state.triggerwindow = !state.triggerwindow
     },
     mFetchTriggerNames(state,val) {
        state.triggerNames =val 
      },
   mActiveTrigger(state,index){ 
      let pageid = state.selectedPage
    state.triggerValues = null
    if(state.activeTriggerIndex == null ){
      state.activeTriggerIndex = index
      var trgid = state.triggerNames[index].docid
      var trgName = db.doc('pages/'+pageid+'/triggers/'+trgid).get()
          .then(doc => {
            if (!doc.exists) {
              console.log('No such document!');
            } else {
              state.triggerValues = doc.data().values  
              state.responseNames = doc.data().responses
            }
          })
          .catch(err => {
            console.log('Error getting document', err);
          });     
      state.triggerNames[state.activeTriggerIndex].active = true      
      state.activeResponseIndex = null
      state.responseCards = null
    }
    else if (state.activeTriggerIndex == index && state.triggerNames[index].active == true){
      state.activeTriggerIndex = null
      state.triggerValues = null
      state.responseNames = null
      state.activeResponseIndex = null
      state.responseCards = null
      state.triggerNames[index].active = !state.triggerNames[index].active
    }
    else if (state.activeTriggerIndex == index && state.triggerNames[index].active == false)
    { 
      state.triggerNames[index].active = !state.triggerNames[index].active
      state.activeResponseIndex = null
      state.responseCards = null
    }
    else{
      state.triggerNames[state.activeTriggerIndex].active = false
      state.activeTriggerIndex = index
      var trgid = state.triggerNames[index].docid
      var trgName = db.doc('pages/'+pageid+'/triggers/'+trgid).get()
          .then(doc => {
            if (!doc.exists) {
              console.log('No such document!');
            } else {
              state.triggerValues = doc.data().values  
              state.responseNames = doc.data().responses
            }
          })
          .catch(err => {
            console.log('Error getting document', err);
          }); 

      state.triggerNames[state.activeTriggerIndex].active = true
      state.activeResponseIndex = null
      state.responseCards = null
    }
   },
   mActiveResponse(state,index){
    let pageid = state.selectedPage
    if(state.activeResponseIndex == null ){
      state.activeResponseIndex = index
      let resp = state.responseNames[index].docid
      console.log(resp)
      var trgName = db.doc('pages/'+pageid+'/responses/'+resp).get()
          .then(doc => {
            if (!doc.exists) {
              console.log('No such document!');
            } else {
              state.responseCards = doc.data().cards
              state.quickreplies = doc.data().quickreplies
            }
          })
          .catch(err => {
            console.log('Error getting document', err);
          });
      state.responseNames[state.activeResponseIndex].active = true
    }
    else if (state.activeResponseIndex == index && state.responseNames[index].active == true){
      state.activeResponseIndex = null
      state.responseCards = null
      state.responseNames[index].active = !state.responseNames[index].active
    }    
    else{
      state.responseNames[state.activeResponseIndex].active = false
      state.activeResponseIndex = index
      let resp = state.responseNames[index].docid
      var trgName = db.doc('pages/'+pageid+'/responses/'+resp).onSnapshot
            (doc=>{
              state.responseCards = doc.data().cards        
            })       
      state.responseNames[state.activeResponseIndex].active = true
    }
   },
   mAddNewTriggerValue(state,{index,trgval}){     
    let pageid = state.selectedPage
      state.triggerValues.push(trgval) 
      var trgid = state.triggerNames[index].docid 
      var trgName = db.doc('pages/'+pageid+'/triggers/'+trgid).update
      ({        
        'values': state.triggerValues                                                        
     })    
   },
   mTrgValueDelete(state,{index,val}){
    let pageid = state.selectedPage
     let del =  state.triggerValues.filter(
      function(value) {
       return value !== val
        }
      )
      state.triggerValues = del 
      var trgid = state.triggerNames[index].docid
        var trgName = db.doc('pages/'+pageid+'/triggers/'+trgid).update({
        'values': state.triggerValues                                                        
     })
   },
   mTrgSave(state,trigger){
    let pageid = state.selectedPage
    var addDoc = db.collection('pages/'+pageid+'/triggers/').add({"name":trigger.name,"values":trigger.values,"active":false,"responses":[]}).then(ref => {  
    let trg = {"active":false, "name":trigger.name, "docid":ref.id}
    if(state.triggerNames == null){
      state.triggerNames =[trg]
    }
    else{
      state.triggerNames.push(trg)
    } 
        var trgName = db.doc('pages/'+pageid).update({
        'triggers': state.triggerNames                                                       
      })
       state.newcard = false
    })
  },
    mEditedTrgValueDelete(state,del){
      state.editTrgValues = del
    },
    mEditedTrgSave(state,trigger){
        let pageid = state.selectedPage
        var trgid = state.triggerNames[state.editTrgIndex].docid 
          var trgName = db.doc('pages/'+pageid+'/triggers/'+trgid).update({
          'name': trigger.name,
          'values': trigger.values,
          'active': false                                                        
      })
      var newtriger = {'name': trigger.name,'active': false, docid:trgid}
      state.triggerNames.splice(state.editTrgIndex,1,newtriger)
        var trgName = db.doc('pages/'+pageid).update({
       'triggers': state.triggerNames                                                           
      })
      state.triggerValues = trigger.values
      state.triggerNames[state.editTrgIndex].active = true
      state.editcard = false
      state.editTrgIndex = null
   },
   mDeleteTrgCard(state,index){
      let pageid = state.selectedPage
      var trgid = state.triggerNames[index].docid 
      var trgName = db.doc('pages/'+pageid+'/triggers/'+trgid).delete()
    state.triggerNames.splice(index,1)
    state.activeTriggerIndex = null
      var trg = db.doc('pages/'+pageid).update({
      'triggers': state.triggerNames                                                           
     })
   },
   mDeleteResponse(state,index){ 
    let pageid = state.selectedPage    
    var trgid = state.triggerNames[index].docid 
    let resp = state.responseNames[index].docid
    state.responseCards = null    
      var resName = db.doc('pages/'+pageid+'/responses/'+resp).delete()
    var res = state.responseNames.splice(index,1)
    state.activeResponseIndex = null
      var trgName = db.doc('pages/'+pageid+'/triggers/'+trgid).update({
      'responses': state.responseNames                                                       
    })
   },
   mDeleteResponseCard(state){
    let pageid = state.selectedPage
    let resp = state.responseNames[state.activeResponseIndex].docid
    state.responseCards.splice(state.activeResponseCardIndex,1)
    state.activeResponseCardIndex = null
      var trgName = db.doc('pages/'+pageid+'/responses/'+resp).update({
      'cards': state.responseCards                                                             
     })
   },
   mUpdateNewResponseCard(state,value){
     state.newResponseCard.text = value
     console.log(state.newResponseCard)
   },
   mNewcardType(state,value){
     console.log("mutation")
     state.newResponseCard.type = value
     console.log(state.newResponseCard.type)
   },
   mNewResponseName(state,value){
    state.newResponse = value
    console.log(state.newResponse)
  },
  mSaveResponse(state,value){ 
    console.log("from response "+value)
    let pageid = state.selectedPage
     var addDoc = db.collection('pages/'+pageid+'/responses/').add({"cards":[value]}).then(ref => {  
      let response = {"active":false, "name":state.newResponse, "docid":ref.id} 
      let trgid = state.triggerNames[state.activeTriggerIndex].docid
      state.responseNames.push(response)
        var trgName = db.doc('pages/'+pageid+'/triggers/'+trgid).update({
        'responses': state.responseNames                                                       
      })    
      state.newResponse = null
      state.newResponseCard = {}
    });
  },
  mSaveResponseCard(state,value){  
    console.log("from response card") 
    let pageid = state.selectedPage
    let resp = state.responseNames[state.activeResponseIndex].docid
    state.responseCards.push(value)
      var trgName = db.doc('pages/'+pageid+'/responses/'+resp).update({
      'cards': state.responseCards                                                        
    })
    console.log("saved response card")    
    state.newResponseCard = {}
  },
  mSaveQuickreply(state,value){  
    let pageid = state.selectedPage 
    let resp = state.responseNames[state.activeResponseIndex].docid
    if (state.quickreplies == null){
      state.quickreplies = [value]
    }
    else{
    state.quickreplies.push(value)
    }
      var trgName = db.doc('pages/'+pageid+'/responses/'+resp).update({
      'quickreplies': state.quickreplies                                                        
    })
  },
  mDeleteQuickReply(state,index){
    let pageid = state.selectedPage
    let resp = state.responseNames[state.activeResponseIndex].docid
    state.quickreplies.splice(index,1)
      var trgName = db.doc('pages/'+pageid+'/responses/'+resp).update({
      'quickreplies': state.quickreplies                                                        
    })
  },
  mActiveResponseCard(state,index){
    if(state.activeResponseCardIndex == null){
    state.activeResponseCardIndex = index
    state.responseCards[state.activeResponseCardIndex].active = true
    }
    else if (state.activeResponseCardIndex == index){
      state.responseCards[state.activeResponseCardIndex].active = false
      state.activeResponseCardIndex = null
    }
    else
    {
      state.responseCards[state.activeResponseCardIndex].active = false
      state.activeResponseCardIndex = index      
      state.responseCards[state.activeResponseCardIndex].active = true
    }
  },
  mMoveResponseCardDown(state,index){
    console.log(state.responseCards) 
    let pageid = state.selectedPage
    let card = state.responseCards[index]
    state.responseCards.splice(index,1)
    state.responseCards.splice(index+1,0,card)
    let resp = state.responseNames[state.activeResponseIndex].docid
    state.responseCards[state.activeResponseCardIndex].active = false
      var trgName = db.doc('pages/'+pageid+'/responses/'+resp).update({
      'cards': state.responseCards                                                       
    })
    state.activeResponseCardIndex = index+1
    state.responseCards[index+1].active = true
  },
  mMoveResponseCardUp(state,index){
    console.log(state.responseCards)
    let pageid = state.selectedPage
    let card = state.responseCards[index]
    state.responseCards.splice(index,1)
    state.responseCards.splice(index-1,0,card)
    let resp = state.responseNames[state.activeResponseIndex].docid
    state.responseCards[state.activeResponseCardIndex].active = false
      var trgName = db.doc('pages/'+pageid+'/responses/'+resp).update({
      'cards': state.responseCards                                                       
    })
    state.activeResponseCardIndex = index-1
    
    state.responseCards[index-1].active = true
  },
  // Above this line code need to review
  mFetchfbdata(state){
    FB.getLoginStatus(function(response) {
      if(response.status == 'connected') {
              let userAccessToken = response.authResponse.accessToken
              console.log(response.authResponse.accessToken)
              FB.api('/me/accounts','GET',
              {"access_token" : response.authResponse.accessToken},
              function(response) {
                  let pagesList = response.data
                  let bots = [];
                  for(let i in pagesList){
                    FB.api(
                      "/"+pagesList[i].id+"/picture?access_token=" +pagesList[i].access_token, 
                      'GET',
                        {
                            "redirect": "0", "height":"60", "width":"60"
                        },                     
                          function (response) {
                            Vue.set(pagesList[i], 'imageurl', response.data.url)
                            Vue.set(pagesList[i], 'isBot', false)   
                            Vue.set(pagesList[i], 'userAccessToken', userAccessToken)
                            FB.api(
                              "/"+pagesList[i].id+"/subscribed_apps?access_token=" +pagesList[i].access_token,
                              'GET',
                              function (response) { 
                                console.log(response)
                                  if(response.data.length != 0) {               
                                      bots.push(pagesList[i])
                                      Vue.set(pagesList[i], 'isBot', true) 
                                  }
                                  state.botsList = bots                     
                              }
                              );
                            
                          }
                      );


                  }
                  state.pagesList = pagesList
                  console.log(state.pagesList)
              }
          );    
          }
      else{ 
      console.log(response.status)   
      console.log("unable to get login status") 
      // FB.login(function(response){
      //   console.log(response)
      // });
      FB.getLoginStatus(function(response) {
        console.log(response)
      })
      }     
      })
  },
  mFetchpagedata(state,pageid){
    FB.getLoginStatus(function(response) {
      if(response.status == 'connected') {
        let userAccessToken = response.authResponse.accessToken
              FB.api(
                      "/"+pageid+"?access_token=" +response.authResponse.accessToken, 
                      'GET',
                      {
                        "fields": ["id","name","picture","access_token","username"]
                      },                    
                          function (response) {
                            Vue.set(state.pageDetails, 'page_id', response.id) 
                              Vue.set(state.pageDetails, 'name', response.name) 
                              Vue.set(state.pageDetails, 'imageurl', response.picture.data.url)
                              Vue.set(state.pageDetails, 'accessToken', response.access_token)
                              Vue.set(state.pageDetails, 'username', response.username)
                              Vue.set(state.pageDetails, 'userAccessToken', userAccessToken)
                              console.log(state.pageDetails) 
                              
                              FB.api(
                                "/"+pageid+"/messenger_profile?access_token=" +state.pageDetails.accessToken, 
                                'GET',
                                    {
                                      "fields": ["persistent_menu","get_started","greeting","whitelisted_domains","home_url"]
                                    },                     
                                    function (response) {
                                      Vue.set(state.pageDetails, 'get_started', response.data[0].get_started) 
                                      Vue.set(state.pageDetails, 'home_url', response.data[0].home_url)
                                      Vue.set(state.pageDetails, 'persistent_menu', response.data[0].persistent_menu)
                                      Vue.set(state.pageDetails, 'whitelisted_domains', response.data[0].whitelisted_domains)
                                      Vue.set(state.pageDetails, 'greeting', response.data[0].greeting)
                                        console.log(state.pageDetails)                       
                                    }
                                );
                                FB.api(
                                "/"+pageid+"/subscribed_apps?access_token=" +state.pageDetails.accessToken,
                                'GET',
                                function (response) { 
                                  if(response.data.length != 0) {         
                                      Vue.set(state.pageDetails, 'subscribed', true)                  
                                  }
                                  else{
                                    Vue.set(state.pageDetails, 'subscribed', false)        
                                  }
                              });
                              FB.api(
                                "/page_message_tags?access_token=" +state.pageDetails.accessToken,
                                'GET',
                                function (response) { 
                                  state.bmessageTags = response.data
                                  console.log(response.data)
                              });                              
                          }
                      );
              
                          
          }
      else{    
      console.log("unable to get login status") 
      }   
      })
  },
  mSelectedPage(state,pageid){
    state.selectedPage = pageid
    console.log(state.selectedPage)
  },
  mfetchBTemplates(state){
    let pageid = state.selectedPage
    state.bTemplateNames = []
    state.bTemplateindex = null
    console.log(pageid)
    var trgName = db.collection('pages/'+pageid+'/broadcast').orderBy("name").get()
    .then(function(querySnapshot) {
      if(querySnapshot.size > 0){
      querySnapshot.forEach(function(doc) {
        let message = {}
        message.id = doc.id
        message.active = false
        message.name = doc.data().name
        message.messages = doc.data().messages
        message.quickreplies = doc.data().quickreplies
        state.bTemplateNames.push(message)
          // doc.data() is never undefined for query doc snapshots
          console.log(doc.id, " => ", doc.data().messages);
      });
      state.bTemplateNames[0].active = true
      state.bTemplateindex = 0
      }
  });
  },
  mfetchresponses(state){
    let pageid = state.selectedPage
    console.log(pageid)
    state.responses = []
    state.uservars = []
    state.currentResponseIndex = null
    var resp = db.collection('pages/'+pageid+'/responses').orderBy("name").get()
    .then(function(querySnapshot) {
      if(querySnapshot.size > 0){
      querySnapshot.forEach(function(doc) {
        let message = {}
        message.id = doc.id
        message.active = false
        message.name = doc.data().name
        message.messages = doc.data().messages
        message.quickreplies = doc.data().quickreplies
        message.ref = doc.data().ref
        state.responses.push(message)
          // doc.data() is never undefined for query doc snapshots
          console.log(doc.id, " => ", doc.data().messages);
      });
      state.responses[0].active = true
      state.currentResponseIndex = 0
      }
  });
  console.log(state.responses)
    var uservars = db.doc('pages/'+pageid).get()
      .then(doc =>{
        if(doc.data().uservars == undefined ){
          state.uservars = []
        }
        else{
        state.uservars = doc.data().uservars
        console.log(state.uservars)
        }
      }
      )
  },
  mcreateBTemeplate(state, message){
    let pageid = state.selectedPage
    state.bTemplateNames.push({"name":message})
    let len = state.bTemplateNames.length
    if(state.bTemplateindex != null)  {  
    state.bTemplateNames[state.bTemplateindex].active = false
    }
    var trgName = db.collection('pages/'+pageid+'/broadcast')
    .add({
      "name":message,
      "messages":[],
      "quickreplies":{"index":null,"qreplies":[]}
    })
    .then(ref => {
      state.bTemplateindex = len-1
      state.bTemplateNames[len-1].active = true
      state.bTemplateNames[state.bTemplateindex].id = ref.id
      state.bTemplateNames[state.bTemplateindex].messages = []
        console.log(state.bTemplateNames[state.bTemplateindex])
    })
  },
  mcreateResponse(state, message){
    let pageid = state.selectedPage
    state.responses.push({"name":message})
    let len = state.responses.length
    if(state.currentResponseIndex != null)  {  
    state.responses[state.currentResponseIndex].active = false
    }
    var respName = db.collection('pages/'+pageid+'/responses')
    .add({
      "name":message,
      "messages":[],
      "quickreplies":{"index":null,"qreplies":[]},
      "ref":""
    })
    .then(ref => {
      state.currentResponseIndex = len-1
      state.responses[len-1].active = true
      state.responses[state.currentResponseIndex].id = ref.id
      state.responses[state.currentResponseIndex].messages = []
      state.responses[state.currentResponseIndex].quickreplies = {"index":null,"qreplies":[]}
    })
  },
  mbcastmenuStatusChange(state,status){
    state.bcastmenuStatus = status
    console.log(state.bcastmenuStatus)
  },
  mresponsemenuStatusChange(state,status){
    state.responseMenuStatus = status
    console.log(state.responseMenuStatus)
  },
  mrulemenuStatusChange(state,status){
    state.ruleMenuStatus = status
    console.log(state.responseMenuStatus)
  },
  mcreatebcastTextMessage(state,{index,message}){
    let pageid = state.selectedPage
    let docId = state.bTemplateNames[index].id
    state.bTemplateindex = index    
    state.bTemplateNames[state.bTemplateindex].active = true
    if(state.bTemplateNames[index].messages){
      state.bTemplateNames[index].messages.push(message)                                                    
    }
    else{
      state.bTemplateNames[index].messages = [message]
    }
     //   Set quick replies to last element
        let messageslength = state.bTemplateNames[index].messages.length
        let currentindex = messageslength - 1
        // console.log(state.bTemplateNames[index].quickreplies.index)
        // console.log(currentindex)
        validateqr()
        function validateqr(){     
          let mtype = state.bTemplateNames[index].messages[currentindex].type
          if(mtype == "text" || mtype == "button" || mtype == "generic" || mtype == "image" || mtype == "video" || mtype == "audio" || mtype == "file" || mtype == "media" || mtype == "list"){
            state.bTemplateNames[index].quickreplies.index = currentindex
            console.log(state.bTemplateNames[index].quickreplies.index)
            if(state.bTemplateNames[index].quickreplies.qreplies.length > 0){ 
            for (let i in state.bTemplateNames[index].messages){          
              if (i == currentindex){
                Vue.set(state.bTemplateNames[index].messages[i].message, 'quick_replies', state.bTemplateNames[index].quickreplies.qreplies) 
              }else{
                if( state.bTemplateNames[index].messages[i].type == 'delay'){  
                                 
                  }
                  else{
                    if(state.bTemplateNames[index].messages[i].message.quick_replies){
                      Vue.delete(state.bTemplateNames[index].messages[i].message,'quick_replies')
                    }
                  }
                }
              }
            }
            }
            else{
              currentindex = currentindex - 1
              validateqr()
            }
          }
     //   
    var bcast = db.doc('pages/'+pageid+'/broadcast/'+docId).update({
      'messages': state.bTemplateNames[index].messages,
      'quickreplies': state.bTemplateNames[index].quickreplies                
    })
  },
  mcreateresponseMessage(state,{index,message}){
    let pageid = state.selectedPage
    let docId = state.responses[index].id
    state.currentResponseIndex = index    
    state.responses[state.currentResponseIndex].active = true
    if(state.responses[index].messages){
      state.responses[index].messages.push(message)                                                    
    }
    else{
      state.responses[index].messages = [message]
    }
    // Set quick replies to last element
    let messageslength = state.responses[index].messages.length
    let currentindex = messageslength - 1
    console.log(state.responses[index].quickreplies.index)
    console.log(currentindex)
    validateqr()
    function validateqr(){   
      console.log(state.responses[index].messages[currentindex])  
      let mtype = state.responses[index].messages[currentindex].type
      console.log(mtype)
      if(mtype == "text" || mtype == "button" || mtype == "generic" || mtype == "image" || mtype == "video" || mtype == "audio" || mtype == "file" || mtype == "media" || mtype == "list")
        {
        state.responses[index].quickreplies.index = currentindex
        console.log(state.responses[index].quickreplies.index)
        if(state.responses[index].quickreplies.qreplies.length > 0){ 
        for (let i in state.responses[index].messages){          
          if (i == currentindex){
            Vue.set(state.responses[index].messages[i].message, 'quick_replies', state.responses[index].quickreplies.qreplies) 
          }else{
            if( state.responses[index].messages[i].type == 'delay' || state.responses[index].messages[i].type == 'userinput' || state.responses[index].messages[i].type == 'setvar' || state.responses[index].messages[i].type == 'integration')
              {  
                     console.log("nothing to set")        
              }
              else{
                if(state.responses[index].messages[i].message.quick_replies){
                  Vue.delete(state.responses[index].messages[i].message,'quick_replies')
                }
              }
            }
          }
        }
        }
        else{
          currentindex = currentindex - 1
          console.log(currentindex)
          if (currentindex < 0){
            console.log("nothing to set")
          }
          else{
            validateqr()
          }
          
        }
      }
    //
    var bcast = db.doc('pages/'+pageid+'/responses/'+docId).update({
      'messages': state.responses[index].messages,
      'quickreplies': state.responses[index].quickreplies                
    })

    if(message.type == 'userinput'){
      let newvar = message.savetovar
      let allvars = state.uservars
      let varindex = allvars.indexOf(newvar)
      console.log(newvar)
      console.log(varindex)
      if (varindex == -1){
        state.uservars.push(newvar)
        console.log(state.uservars)
        var setvars = db.doc('pages/'+pageid).update({
          'uservars': state.uservars             
        })

      }
      else {
        console.log(newvar)
        console.log(state.uservars)
      }
    }
    else if(message.type == 'setvar'){
      let newvar = message.setvar
      let allvars = state.uservars
      let varindex = allvars.indexOf(newvar)
      if (varindex == -1){
        state.uservars.push(newvar)
        var setvars = db.doc('pages/'+pageid).update({
          'uservars': state.uservars             
        })

      }
      else {
        console.log(newvar)
        console.log(state.uservars)
      }

    }

    else if(message.type == 'generic' && message.gsheetStatus == true){
      ////////////////////////
      // column name res name + pageid + docId + index
      // column names are default
      // column values are the array of gallery
      console.log(pageid)
      console.log(docId)
      console.log(state.responses[index].name)
      console.log(state.responses[index].messages.length)
      console.log(message.message)
           let response_name = state.responses[index].name;
           let response_index = state.responses[index].messages.length;
           let column_values = message.message;
          let res1 = axios({
                    method: "post",
                    url: "https://small-umbra.glitch.me/linkGalleryToGoogleSheet",
                    data: {column_values},
                    params: {pageid,docId,response_index,response_name}
                })
            .then(response => {
                console.log(response)
                let sheetId = response.data.sheetId
                console.log(sheetId)
                console.log(response_index)
                console.log(response_index-1)
                console.log(state.responses[index].messages[response_index-1].gsheetId)
                state.responses[index].messages[response_index-1].gsheetId = sheetId
                console.log(state.responses[index].messages[response_index-1].gsheetId)
                var bcast = db.doc('pages/'+pageid+'/responses/'+docId).update({
                  'messages': state.responses[index].messages,
                  'quickreplies': state.responses[index].quickreplies          
                })
                //let gsheets = {"name":sheet_name, "sheetId":sheetId, "columnValues":sheet_columns}
            })
            .catch(error => {
            console.log(error)
            })
    ////////////////////////////////////
    }
  },
  mbcastTemplateIndexChange(state,{index}){
    state.bTemplateNames[state.bTemplateindex].active = false
    state.bTemplateindex = index    
    state.bTemplateNames[state.bTemplateindex].active = true
  },
  mresponseIndexChange(state,{index}){
    state.responses[state.currentResponseIndex].active = false
    state.currentResponseIndex = index    
    state.responses[state.currentResponseIndex].active = true
  },
  mupdateBTemeplate(state,message){
    console.log(message)
    let pageid = state.selectedPage
    let docId = state.bTemplateNames[state.bTemplateindex].id 
    state.bTemplateNames[state.bTemplateindex].name  = message
    var bcast = db.doc('pages/'+pageid+'/broadcast/'+docId).update({
      'name': message                                                      
    })
  },
  mupdateResponse(state,message){
    console.log(message)
    let pageid = state.selectedPage
    let docId = state.responses[state.currentResponseIndex].id 
    state.responses[state.currentResponseIndex].name  = message
    var bcast = db.doc('pages/'+pageid+'/responses/'+docId).update({
      'name': message                                                      
    })
  },
  mbcastdeleteTemplate(state,{index}){
    let pageid = state.selectedPage
    let docId = state.bTemplateNames[index].id
    if (state.bTemplateNames.length > 1)
    {
      state.bTemplateNames.splice(index,1)
      var bcast = db.doc('pages/'+pageid+'/broadcast/'+docId).delete()
      state.bTemplateindex = index-1
      state.bTemplateNames[state.bTemplateindex].active = true
    }
    else{
      state.bTemplateNames.splice(index,1)
      var bcast = db.doc('pages/'+pageid+'/broadcast/'+docId).delete()
      state.bTemplateindex = null
    }
  },
  mresponsedelete(state,{index}){
    let pageid = state.selectedPage
    let docId = state.responses[index].id
    if (state.responses.length > 1)
    {
      state.responses.splice(index,1)
      var bcast = db.doc('pages/'+pageid+'/responses/'+docId).delete()
      state.currentResponseIndex = index-1
      state.responses[state.currentResponseIndex].active = true
    }
    else{
      state.responses.splice(index,1)
      var bcast = db.doc('pages/'+pageid+'/responses/'+docId).delete()
      state.currentResponseIndex = null
    }
  },
  mupdatebcastMessage(state,{index}){
    let pageid = state.selectedPage
    let docId = state.bTemplateNames[state.bTemplateindex].id   
    state.bTemplateNames[state.bTemplateindex].messages.splice(index,1)
            // Set quick replies to last element
            let currentindex
            let messageslength = state.bTemplateNames[state.bTemplateindex].messages.length
            if(messageslength >= 1){
              currentindex = messageslength - 1
              validateqr()
            }
            // let currentindex = messageslength - 1
            // console.log(currentindex)
            // validateqr()
            function validateqr(){     
              let mtype = state.bTemplateNames[state.bTemplateindex].messages[currentindex].type
              if(mtype == "text" || mtype == "button" || mtype == "generic" || mtype == "image" || mtype == "video" || mtype == "audio" || mtype == "file" || mtype == "media" || mtype == "list"){
                state.bTemplateNames[state.bTemplateindex].quickreplies.index = currentindex
                if(state.bTemplateNames[state.bTemplateindex].quickreplies.qreplies.length > 0){
                for (let i in state.bTemplateNames[state.bTemplateindex].messages){          
                  if (i == currentindex){
                    Vue.set(state.bTemplateNames[state.bTemplateindex].messages[i].message, 'quick_replies', state.bTemplateNames[state.bTemplateindex].quickreplies.qreplies) 
                  }else{
                    if( state.bTemplateNames[state.bTemplateindex].messages[i].type == 'delay' ){  
                                 
                    }
                    else{
                       if(state.bTemplateNames[state.bTemplateindex].messages[i].message.quick_replies){
                          Vue.delete(state.bTemplateNames[state.bTemplateindex].messages[i].message,'quick_replies')
                       }
                      }
                    }
                  }
                }
                }
                else{
                  currentindex = currentindex - 1
                  validateqr()
                }
              }
            //
    var bcast = db.doc('pages/'+pageid+'/broadcast/'+docId).update({
      'messages': state.bTemplateNames[state.bTemplateindex].messages,
      'quickreplies': state.bTemplateNames[state.bTemplateindex].quickreplies                                                  
    })
  },
  mupdateresponseMessage(state,{index}){
    let pageid = state.selectedPage
    let docId = state.responses[state.currentResponseIndex].id   
    state.responses[state.currentResponseIndex].messages.splice(index,1)
        // Set quick replies to last element
        let messageslength = state.responses[state.currentResponseIndex].messages.length
        let currentindex 
        if(messageslength >= 1){
          currentindex = messageslength - 1
          validateqr()
        }       
        // let currentindex = messageslength - 1
        // console.log(currentindex)
        // validateqr()
        function validateqr(){     
          let mtype = state.responses[state.currentResponseIndex].messages[currentindex].type
          if(mtype == "text" || mtype == "button" || mtype == "generic" || mtype == "image" || mtype == "video" || mtype == "audio" || mtype == "file" || mtype == "media" || mtype == "list"){
            state.responses[state.currentResponseIndex].quickreplies.index = currentindex
            if(state.responses[state.currentResponseIndex].quickreplies.qreplies.length > 0){
            for (let i in state.responses[state.currentResponseIndex].messages){          
              if (i == currentindex){
                Vue.set(state.responses[state.currentResponseIndex].messages[i].message, 'quick_replies', state.responses[state.currentResponseIndex].quickreplies.qreplies) 
              }else{
                if( state.responses[state.currentResponseIndex].messages[i].type == 'delay' || state.responses[state.currentResponseIndex].messages[i].type == 'userinput' || state.responses[state.currentResponseIndex].messages[i].type == 'setvar' || state.responses[state.currentResponseIndex].messages[i].type == 'integration'){  
                             
                }
                else{
                   if(state.responses[state.currentResponseIndex].messages[i].message.quick_replies){
                      Vue.delete(state.responses[state.currentResponseIndex].messages[i].message,'quick_replies')
                   }
                  }
                }
              }
            }
            }
            else{
              currentindex = currentindex - 1
              validateqr()
            }
          }
        //
    var bcast = db.doc('pages/'+pageid+'/responses/'+docId).update({
      'messages': state.responses[state.currentResponseIndex].messages,
      'quickreplies': state.responses[state.currentResponseIndex].quickreplies                                                      
    })
  },
  mupdateMessageDelay(state,{index,value}){
    let pageid = state.selectedPage
    let docId = state.responses[state.currentResponseIndex].id
    state.responses[state.currentResponseIndex].messages[index].delay = value
    var bcast = db.doc('pages/'+pageid+'/responses/'+docId).update({
      'messages': state.responses[state.currentResponseIndex].messages                                                     
    })

  },
  mgeneratemessengercode(state,{refcode,size}){
    let pageid = state.selectedPage
    let accessToken = state.pageDetails.accessToken
    if(refcode != null)
    {
      FB.api(
        "/"+pageid+"/messenger_codes?access_token=" +accessToken,
        'POST',
        {
            "type": "standard",
            "data": {
                "ref":refcode
                },
            "image_size": size    
        },
        function (response) {
            console.log(response)
            state.messengercodeurl = response.uri
      })
    }
    else{
      FB.api(
        "/"+pageid+"/messenger_codes?access_token=" +accessToken,
        'POST',
        {
            "type": "standard",
            "image_size": size    
        },
        function (response) {
            console.log(response)
            state.messengercodeurl = response.uri
      })
    }
  },
  mfetchrules(state){
    let pageid = state.selectedPage
    state.rules = []
    var rules = db.collection('pages/'+pageid+'/rules').get()
      .then(function(querySnapshot) {
        if(querySnapshot.size > 0){
        querySnapshot.forEach(function(doc) {
          let keywords = doc.data().keywords
          let responses = doc.data().responses
          let rules = {"keywords":keywords,"responses":responses,"docid":doc.id}
          state.rules.push(rules)
            console.log(state.rules);
        });
        }
    });
  },
  mcreaterule(state,{rule}){
    console.log(rule)    
    let pageid = state.selectedPage
    var crule = db.collection('pages/'+pageid+'/rules')
    .add({
      "keywords":rule.keywords,
      "responses":rule.responses
    })
    .then(ref => {
      Vue.set(rule, 'docid', ref.id) 
      state.rules.push(rule)
    })   
  },
  mruleindexChange(state,index){
    state.currentruleindex = index
  },
  mupdaterule(state,{rule,index}){ 
    let pageid = state.selectedPage
    let docId = state.rules[index].docid
    console.log(rule.keywords.length)
    if(rule.keywords.length == 0){
      var crule = db.doc('pages/'+pageid+'/rules/'+docId).delete()
      state.rules.splice(index,1)
    }
    else{      
      var crule = db.doc('pages/'+pageid+'/rules/'+docId).update({
        "keywords":rule.keywords,
        "responses":rule.responses                                                    
      })
      state.rules[index].responses = rule.responses
      state.rules[index].keywords = rule.keywords 
    }
  },
  mcreatequickreply(state,{quickreply}){
    let pageid = state.selectedPage
    let docId = state.responses[state.currentResponseIndex].id    
    state.responses[state.currentResponseIndex].quickreplies.qreplies.push(quickreply)
    if(state.responses[state.currentResponseIndex].quickreplies.index != null){
      let qrindex = state.responses[state.currentResponseIndex].quickreplies.index        
      for (let i in state.responses[state.currentResponseIndex].messages){          
        if (i == qrindex){
          Vue.set(state.responses[state.currentResponseIndex].messages[i].message, 'quick_replies', state.responses[state.currentResponseIndex].quickreplies.qreplies) 
        }else{
          if( state.responses[state.currentResponseIndex].messages[i].type == 'delay' || state.responses[state.currentResponseIndex].messages[i].type == 'setvar' || state.responses[state.currentResponseIndex].messages[i].type == 'userinput'){  
                             
          }
          else{
              if(state.responses[state.currentResponseIndex].messages[i].message.quick_replies){
                Vue.delete(state.responses[state.currentResponseIndex].messages[i].message,'quick_replies')
              }
            }
          }
        }
    }
    var qreply = db.doc('pages/'+pageid+'/responses/'+docId).update({
      'messages': state.responses[state.currentResponseIndex].messages,
      'quickreplies': state.responses[state.currentResponseIndex].quickreplies                                                    
    })
  },
  mdeletequickreply(state,{qrindex}){
    let pageid = state.selectedPage
    let docId = state.responses[state.currentResponseIndex].id    
    state.responses[state.currentResponseIndex].quickreplies.qreplies.splice(qrindex,1)
    if(state.responses[state.currentResponseIndex].quickreplies.index != null ){
      let qrindex = state.responses[state.currentResponseIndex].quickreplies.index        
      for (let i in state.responses[state.currentResponseIndex].messages){          
        if (i == qrindex && state.responses[state.currentResponseIndex].quickreplies.qreplies.length > 0){
          Vue.set(state.responses[state.currentResponseIndex].messages[i].message, 'quick_replies', state.responses[state.currentResponseIndex].quickreplies.qreplies) 
        }else{
          if( state.responses[state.currentResponseIndex].messages[i].type == 'delay' || state.responses[state.currentResponseIndex].messages[i].type == 'userinput' || state.responses[state.currentResponseIndex].messages[i].type == 'setvar' ){  
                             
          }
          else{
              if(state.responses[state.currentResponseIndex].messages[i].message.quick_replies){
                Vue.delete(state.responses[state.currentResponseIndex].messages[i].message,'quick_replies')
              }
            }
          }
        }
    }
    var qreply = db.doc('pages/'+pageid+'/responses/'+docId).update({
      'messages': state.responses[state.currentResponseIndex].messages,
      'quickreplies': state.responses[state.currentResponseIndex].quickreplies                                                    
    })

  },
  mbcastdeletequickreply(state,{qrindex}){
    let pageid = state.selectedPage
    let docId = state.bTemplateNames[state.bTemplateindex].id    
    state.bTemplateNames[state.bTemplateindex].quickreplies.qreplies.splice(qrindex,1)
    if(state.bTemplateNames[state.bTemplateindex].quickreplies.index != null ){
      let qrindex = state.bTemplateNames[state.bTemplateindex].quickreplies.index        
      for (let i in state.bTemplateNames[state.bTemplateindex].messages){          
        if (i == qrindex && state.bTemplateNames[state.bTemplateindex].quickreplies.qreplies.length > 0){
          Vue.set(state.bTemplateNames[state.bTemplateindex].messages[i].message, 'quick_replies', state.bTemplateNames[state.bTemplateindex].quickreplies.qreplies) 
        }else{
          if( state.bTemplateNames[state.bTemplateindex].messages[i].type == 'delay' || state.bTemplateNames[state.bTemplateindex].messages[i].type == 'userinput' || state.bTemplateNames[state.bTemplateindex].messages[i].type == 'setvar'){  
                             
          }
          else{
              if(state.bTemplateNames[state.bTemplateindex].messages[i].message.quick_replies){
                Vue.delete(state.bTemplateNames[state.bTemplateindex].messages[i].message,'quick_replies')
              }
            }
          }
        }
    }
    var qreply = db.doc('pages/'+pageid+'/broadcast/'+docId).update({
      'messages': state.bTemplateNames[state.bTemplateindex].messages,
      'quickreplies': state.bTemplateNames[state.bTemplateindex].quickreplies                                                    
    })

  },
  mbcastcreatequickreply(state,{quickreply}){
    let pageid = state.selectedPage
    let docId = state.bTemplateNames[state.bTemplateindex].id    
    state.bTemplateNames[state.bTemplateindex].quickreplies.qreplies.push(quickreply)
    if(state.bTemplateNames[state.bTemplateindex].quickreplies.index != null){
      let qrindex = state.bTemplateNames[state.bTemplateindex].quickreplies.index        
      for (let i in state.bTemplateNames[state.bTemplateindex].messages){          
        if (i == qrindex){
          Vue.set(state.bTemplateNames[state.bTemplateindex].messages[i].message, 'quick_replies', state.bTemplateNames[state.bTemplateindex].quickreplies.qreplies) 
        }else{
          if( state.bTemplateNames[state.bTemplateindex].messages[i].type == 'delay'){  
                             
          }
          else{
              if(state.bTemplateNames[state.bTemplateindex].messages[i].message.quick_replies){
                Vue.delete(state.bTemplateNames[state.bTemplateindex].messages[i].message,'quick_replies')
              }
            }
          }
        }
    }
    var qreply = db.doc('pages/'+pageid+'/broadcast/'+docId).update({
      'messages': state.bTemplateNames[state.bTemplateindex].messages,
      'quickreplies': state.bTemplateNames[state.bTemplateindex].quickreplies                                                    
    })
  },
  mbcastdeletequickreply(state,{qrindex}){
    let pageid = state.selectedPage
    let docId = state.bTemplateNames[state.bTemplateindex].id    
    state.bTemplateNames[state.bTemplateindex].quickreplies.qreplies.splice(qrindex,1)
    if(state.bTemplateNames[state.bTemplateindex].quickreplies.index != null ){
      let qrindex = state.bTemplateNames[state.bTemplateindex].quickreplies.index        
      for (let i in state.bTemplateNames[state.bTemplateindex].messages){          
        if (i == qrindex && state.bTemplateNames[state.bTemplateindex].quickreplies.qreplies.length > 0){
          Vue.set(state.bTemplateNames[state.bTemplateindex].messages[i].message, 'quick_replies', state.bTemplateNames[state.bTemplateindex].quickreplies.qreplies) 
        }else{
          if( state.bTemplateNames[state.bTemplateindex].messages[i].type == 'delay'){  
                             
          }
          else{
              if(state.bTemplateNames[state.bTemplateindex].messages[i].message.quick_replies){
                Vue.delete(state.bTemplateNames[state.bTemplateindex].messages[i].message,'quick_replies')
              }
            }
          }
        }
    }
    var qreply = db.doc('pages/'+pageid+'/broadcast/'+docId).update({
      'messages': state.bTemplateNames[state.bTemplateindex].messages,
      'quickreplies': state.bTemplateNames[state.bTemplateindex].quickreplies                                                    
    })

  },
  mfetchassets(state){
    let pageid = state.selectedPage
    state.assets = []
    var assets = db.doc('pages/'+pageid+'/attachments/attachmentids').get()
    .then(doc => {
      if (!doc.exists) {
        console.log('No such document!');
      } else {
        state.assets = doc.data().ids
      }
    })
    .catch(err => {
      console.log('Error getting document', err);
    });
  },
  mfetchunknownkeywords(state){
    let pageid = state.selectedPage
    state.unknown_keywords = []
    var assets = db.doc('pages/'+pageid).get()
    .then(doc => {
      if (!doc.exists) {
        console.log('No such document!');
      } else {
        state.unknown_keywords = doc.data().unknown_keywords
      }
    })
    .catch(err => {
      console.log('Error getting document', err);
    });
  },
  mcreateasset(state,{asset}){
    let pageid = state.selectedPage
    if(state.assets.length == 0)
    {
      state.assets.push(asset)
      var assets = db.collection('pages/'+pageid+'/attachments/').doc("attachmentids").set({'ids': state.assets})
    }
    else{
      state.assets.push(asset)
      var assets = db.doc('pages/'+pageid+'/attachments/attachmentids').update({
        'ids': state.assets                                                  
      })
    }
  },
  mupdatesnackbarstatus(state,{status,update,timeout}){
    let sbarupdate = {"status":status, "update":update, "timeout":timeout}
    state.snackbar = sbarupdate
  },
  mwelcomeresponse(state,{pageid,access_token}){
    db.collection("pages/"+pageid+"/responses")
	    .where('name', '==', 'Welcome Response').get()
      .then(function(querySnapshot) { 
          if (querySnapshot.size > 0){
				querySnapshot.forEach(function(doc) {
				    FB.api(
                  "/"+pageid+"/messenger_profile?access_token=" +access_token,
                  'POST',
                      { 
                      "get_started": {"payload":doc.id}
                      },
                  function (response) { 
                      console.log("getstarted configured")
                  })
				})
				console.log("already exist")
			}
			else{
			    var respName = db.collection('pages/'+pageid+'/responses')
				.add({
				  "name":"Welcome Response",
				  "messages":[{"message":{"text":"Welcome {{first_name}}"},"type":"text"}],
          "quickreplies":{"index":null,"qreplies":[]},
          "ref":""
				})
				.then(ref => {
					FB.api(
                "/"+pageid+"/messenger_profile?access_token=" +access_token,
                'POST',
                    { 
                    "get_started": {"payload":ref.id}
                    },
                function (response) { 
                    console.log("getstarted configured")
                }) 
				})
			}
		})	
	.catch(function(error){
		console.log(error)
		})
  },
  mdefaultresponse(state,{pageid,access_token}){
    db.collection("pages/"+pageid+"/responses")
	    .where('name', '==', 'Default Response').get()
      .then(function(querySnapshot) { 
          if (querySnapshot.size > 0){
				querySnapshot.forEach(function(doc) {
          var defaultref = db.doc('pages/'+pageid).update({
            'default': doc.id                                                  
          })
				})
				console.log("already exist")
			}
			else{
			    var respName = db.collection('pages/'+pageid+'/responses')
				.add({
				  "name":"Default Response",
				  "messages":[{"message":{"text":"This is the default response, My Boss is in the process of training me. Please try after some time."},"type":"text"}],
          "quickreplies":{"index":null,"qreplies":[]},
          "ref":""
				})
				.then(ref => {
          var defaultref = db.doc('pages/'+pageid).update({
            'default': ref.id                                                  
          })
				})
			}
		})	
	.catch(function(error){
		console.log(error)
		})
  },
  mupdateref(state,{docId,ref}){
    let pageid = state.selectedPage
    var updateref = db.doc('pages/'+pageid+'/responses/'+docId).update({
      'ref': ref                                                    
    })
  },
  mresponseEditor(state,{index, card}){
    state.cardEditor.index = index
    state.cardEditor.card = card 
    state.cardEditor.docid = state.responses[state.currentResponseIndex].id 
    console.log(state.cardEditor)
  },
  mSaveEditedresponseMessage(state,{editedresponse}){
    let pageid = state.selectedPage
    let response = editedresponse
    console.log(state.cardEditor.card)
    if(state.cardEditor.card.type != "setvar" && state.cardEditor.card.type != "userinput" && state.cardEditor.card.type != "integration"){
      if(state.cardEditor.card.message.quick_replies)
      {  
       response.message.quick_replies = state.cardEditor.card.message.quick_replies
      }
    }
    console.log(state.responses[state.currentResponseIndex].messages)
    console.log(response)
    console.log(state.cardEditor.index)
    state.responses[state.currentResponseIndex].messages.splice(state.cardEditor.index,1,response)
    console.log(state.responses[state.currentResponseIndex].messages)
    var updateref = db.doc('pages/'+pageid+'/responses/'+state.cardEditor.docid).update({
      'messages': state.responses[state.currentResponseIndex].messages                                                    
    })
  },
  mSaveEditedquickreply(state,{quickreply, qrindex}){
    let pageid = state.selectedPage
    state.responses[state.currentResponseIndex].quickreplies.qreplies.splice(qrindex,1,quickreply)
    let messagecount = state.responses[state.currentResponseIndex].messages.length
    state.responses[state.currentResponseIndex].messages[messagecount-1].message.quick_replies = state.responses[state.currentResponseIndex].quickreplies.qreplies
    console.log(state.responses[state.currentResponseIndex])
    var updateref = db.doc('pages/'+pageid+'/responses/'+state.responses[state.currentResponseIndex].id).update({
      'messages': state.responses[state.currentResponseIndex].messages,
      'quickreplies': state.responses[state.currentResponseIndex].quickreplies                                                   
    })
  },
  mupmoveresponseMessage(state,{index}){
    let pageid = state.selectedPage
    let docId = state.responses[state.currentResponseIndex].id 
    let msg1 = state.responses[state.currentResponseIndex].messages[index] 
    let msg2 = state.responses[state.currentResponseIndex].messages[index - 1]
    Vue.set(state.responses[state.currentResponseIndex].messages, index - 1, msg1)
    Vue.set(state.responses[state.currentResponseIndex].messages, index, msg2) 
        // Set quick replies to last element
        let messageslength = state.responses[state.currentResponseIndex].messages.length
        let currentindex 
        if(messageslength >= 1){
          currentindex = messageslength - 1
          validateqr()
        }       
        // let currentindex = messageslength - 1
        // console.log(currentindex)
        // validateqr()
        function validateqr(){     
          let mtype = state.responses[state.currentResponseIndex].messages[currentindex].type
          if(mtype == "text" || mtype == "button" || mtype == "generic" || mtype == "image" || mtype == "video" || mtype == "audio" || mtype == "file" || mtype == "media" || mtype == "list"){
            state.responses[state.currentResponseIndex].quickreplies.index = currentindex
            if(state.responses[state.currentResponseIndex].quickreplies.qreplies.length > 0){
            for (let i in state.responses[state.currentResponseIndex].messages){          
              if (i == currentindex){
                Vue.set(state.responses[state.currentResponseIndex].messages[i].message, 'quick_replies', state.responses[state.currentResponseIndex].quickreplies.qreplies) 
              }else{
                if( state.responses[state.currentResponseIndex].messages[i].type == 'delay'){  
                             
                }
                else{
                   if(state.responses[state.currentResponseIndex].messages[i].message.quick_replies){
                      Vue.delete(state.responses[state.currentResponseIndex].messages[i].message,'quick_replies')
                   }
                  }
                }
              }
            }
            }
            else{
              currentindex = currentindex - 1
              validateqr()
            }
          }
        //
    var bcast = db.doc('pages/'+pageid+'/responses/'+docId).update({
      'messages': state.responses[state.currentResponseIndex].messages,
      'quickreplies': state.responses[state.currentResponseIndex].quickreplies                                                      
    })
  },
  mdownmoveresponseMessage(state,{index}){
    let pageid = state.selectedPage
    let docId = state.responses[state.currentResponseIndex].id 
    let msg1 = state.responses[state.currentResponseIndex].messages[index] 
    let msg2 = state.responses[state.currentResponseIndex].messages[index + 1]
    Vue.set(state.responses[state.currentResponseIndex].messages, index + 1, msg1)
    Vue.set(state.responses[state.currentResponseIndex].messages, index, msg2)
        // Set quick replies to last element
        let messageslength = state.responses[state.currentResponseIndex].messages.length
        let currentindex 
        if(messageslength >= 1){
          currentindex = messageslength - 1
          validateqr()
        }       
        // let currentindex = messageslength - 1
        // console.log(currentindex)
        // validateqr()
        function validateqr(){     
          let mtype = state.responses[state.currentResponseIndex].messages[currentindex].type
          if(mtype == "text" || mtype == "button" || mtype == "generic" || mtype == "image" || mtype == "video" || mtype == "audio" || mtype == "file" || mtype == "media" || mtype == "list"){
            state.responses[state.currentResponseIndex].quickreplies.index = currentindex
            if(state.responses[state.currentResponseIndex].quickreplies.qreplies.length > 0){
            for (let i in state.responses[state.currentResponseIndex].messages){          
              if (i == currentindex){
                Vue.set(state.responses[state.currentResponseIndex].messages[i].message, 'quick_replies', state.responses[state.currentResponseIndex].quickreplies.qreplies) 
              }else{
                if( state.responses[state.currentResponseIndex].messages[i].type == 'delay'){  
                             
                }
                else{
                   if(state.responses[state.currentResponseIndex].messages[i].message.quick_replies){
                      Vue.delete(state.responses[state.currentResponseIndex].messages[i].message,'quick_replies')
                   }
                  }
                }
              }
            }
            }
            else{
              currentindex = currentindex - 1
              validateqr()
            }
          }
        //
    var bcast = db.doc('pages/'+pageid+'/responses/'+docId).update({
      'messages': state.responses[state.currentResponseIndex].messages,
      'quickreplies': state.responses[state.currentResponseIndex].quickreplies                                                      
    })
   },
   mFetchUsers(state,pageid){
    state.pageusers = []
    var qUsers = db.collection('pages/'+pageid+'/users').get()
    .then(function(querySnapshot) {
      if(querySnapshot.size > 0){
      querySnapshot.forEach(function(doc) {
        let docId = doc.id
        let id = doc.data().puid
        let name = doc.data().name
        let createdon = doc.data().createdOn
        let lastuserinteraction = doc.data().latestResponseOn
        let vars = doc.data().vars
        let uservarcount = Object.keys(vars).length
        let optinsource = doc.data().optInSource
        let pUsers = {"userid":id, "username":name,"usercreatedon":createdon,"lastuserinteraction":lastuserinteraction,"varscount":uservarcount,"vars":vars,"optinsource":optinsource,"docId":docId}
        state.pageusers.push(pUsers)
          console.log(state.pageusers);
          });
          }
      })
    .catch(err => {
      console.log('Error getting document', err);
    });

   },
   msaveUservars(state,{setvars,docid}){
    let pageid = state.selectedPage
    let varindex = state.pageusers.map(e => e.docId).indexOf(docid)
    console.log(varindex)
    let userdetails =state.pageusers[varindex] 
    Vue.delete(userdetails,'vars')
    Vue.set(userdetails,'vars',setvars)
    let uservarcount = Object.keys(setvars).length
    Vue.delete(userdetails,'varscount')
    Vue.set(userdetails,'varscount',uservarcount)
    console.log(userdetails)
    state.pageusers.splice(varindex,1,userdetails)
    console.log(state.pageusers)
    var updateVars = db.doc('pages/'+pageid+'/users/'+docid).update({
      'vars': setvars,
      'varscount' : uservarcount                                                   
    })
   },
   mresetgalleryelement(state){
     console.log(state.elements)
     state.elements=[]
    let sample = { "active":false,"title":null,"file":null,"subtitle":null,"image_url":"https://cdn.vuetifyjs.com/images/lists/ali.png","default_action": {
                      "type": "web_url",
                      "url": null,
                      "webview_height_ratio": "tall",
                    },
                  "buttons":[
                  {"label":"First Button","active":false,"title":null,"type":null,"url":null,"webview_height_ratio":"compact","payload":null,"response":null},
                  {"label":"Second Button","active":false,"title":null,"type":null,"url":null,"webview_height_ratio":"compact","payload":null,"response":null},
                  {"label":"Third Button","active":false,"title":null,"type":null,"url":null,"webview_height_ratio":"compact","payload":null,"response":null}
                  ]
                }
      Vue.set(state.elements,0,sample)
    },
    maddNewGalleryCard(state){
      let card ={ "active":false,"title":null,"file":null,"subtitle":null,"image_url":"https://cdn.vuetifyjs.com/images/lists/ali.png","default_action": {
              "type": "web_url",
              "url": null,
              "webview_height_ratio": "tall",
            },
          "buttons":[
          {"label":"First Button","active":false,"title":null,"type":null,"url":null,"webview_height_ratio":"compact","payload":null,"response":null},
          {"label":"Second Button","active":false,"title":null,"type":null,"url":null,"webview_height_ratio":"compact","payload":null,"response":null},
          {"label":"Third Button","active":false,"title":null,"type":null,"url":null,"webview_height_ratio":"compact","payload":null,"response":null}
          ]
         }
      state.elements.push(card)
    },
    mfetchIntegrationDetails(state,pageid){
      console.log(pageid)
      var getsheetsIntegrations = db.doc('/pages/'+pageid+'/integrations/google_sheets').get()
        .then(doc => {
          if (!doc.exists) {
            console.log('No such document!');
            state.google_sheets.status = "noAccess"
          } else {
            state.google_sheets.status = doc.data().access
            console.log(state.google_sheets.status);

          }
        })
        .catch(err => {
          console.log('Error getting document', err);
        }); 
        var getsendgridIntegrations = db.doc('/pages/'+pageid+'/integrations/send_grid').get()
        .then(doc => {
          if (!doc.exists) {
            console.log('No such document!');
            state.send_grid.status = "noAccess"
          } else {
            state.send_grid.status = doc.data().access
            console.log(state.send_grid.status);

          }
        })
        .catch(err => {
          console.log('Error getting document', err);
        });
    },
    mconnectSendgrid(state,{pageid,text}){
      var addKey = db.collection("pages/"+pageid+"/integrations").doc("send_grid").set({
        access:"granted",
        apikey: text
        })
        .then(function(response) {
            console.log("Document successfully written!");
            return response
        })
        .catch(function(error) {
            console.error("Error writing document: ", error);
            return error
        });
    },
    mdisconnectSendgrid(state,pageid){
      var deleteKey = db.collection("pages/"+pageid+"/integrations").doc("send_grid").set({
        access:"revoked"
        })
        .then(function(response) {
            console.log("Document successfully written!");
            return response
        })
        .catch(function(error) {
            console.error("Error writing document: ", error);
            return error
        });
    },
    mdeleteunknownkeyword(state,index){
      let pageid = state.selectedPage
      state.unknown_keywords.splice(index,1)
      let unidentifiedKeyword = db.doc('pages/'+pageid).update({
        'unknown_keywords': state.unknown_keywords                                                      
      })
    },
    mfetchcommmentRules(state){
      let pageid = state.selectedPage
state.commentRules = []
    var crule = db.collection('pages/'+pageid+'/comments').get()
    .then(function(querySnapshot) {
      if(querySnapshot.size > 0){
          querySnapshot.forEach(function(doc) {
              let rule = {}
              rule.id = doc.id
              rule.postid = doc.data().postid
              rule.keywords = doc.data().keywords
              rule.responseid = doc.data().responseid
              rule.responsename = doc.data().responsename
              state.commentRules.push(rule)
          });
      }
    })
    },
    msavecommentRule(state,rule){
      let pageid = state.selectedPage
      let savecommrntrule = db.collection('pages/'+pageid+'/comments').add({
        'postid': rule.postid,
        'keywords': rule.keywords,
        'responseid': rule.responseid,
        'responsename' : rule.responsename                                                 
      }).then(
        ref => {
          state.commentRules.push(
            {
              'id': ref.id,
              'postid': rule.postid,
              'keywords': rule.keywords,
              'responseid': rule.responseid,
              'responsename' : rule.responsename                                                 
            })
        }
      )
    },
    mdeletecommentRule(state,{ruleid,ruleindex}){
      let pageid = state.selectedPage
      let deletecommrntrule = db.doc('pages/'+pageid+'/comments/'+ruleid).delete().then(
        ref =>{
          state.commentRules.splice(ruleindex,1)
        })      
    },
    mupdatecommentRule(state,{updateIndex,ruleid,rule}){
      let pageid = state.selectedPage
      let updatecommrntrule = db.doc('pages/'+pageid+'/comments/'+ruleid).update(
        {
        'postid': rule.postid,
        'keywords': rule.keywords,
        'responseid': rule.responseid,
        'responsename' : rule.responsename
      }
        ).then(
        ref =>{
          let newRule =
            {
              'id': ruleid,
              'postid': rule.postid,
              'keywords': rule.keywords,
              'responseid': rule.responseid,
              'responsename' : rule.responsename                                                 
            }
          state.commentRules.splice(updateIndex,1,newRule)
        })
    }
   
  },
  actions: {
    aFetchTriggerNames({commit,state}){
      let pageid = state.selectedPage
      state.triggerNames = null 
     var trgName = db.doc('/pages/'+pageid).onSnapshot
       (doc=>{
            commit('mFetchTriggerNames',doc.data().triggers)        
        })       
       },
     anewResponseCardWindowStatus({commit},windowStatus){
      commit('mnewResponseCardWindowStatus',windowStatus)
     },
     anewResponseWindowStatus({commit},windowStatus){
      commit('mnewResponseWindowStatus',windowStatus)
     },
     aActiveTrigger({commit,state},index){
      commit('mActiveTrigger',index)
     },
     aAddNewTriggerValue({commit,state},{index,trgval}){
      commit('mAddNewTriggerValue',{index,trgval})
     },
     atrgValueDelete({commit},{index,val}){
      commit('mTrgValueDelete',{index,val})
     },
     aTrgSave({commit},trigger){
      commit('mTrgSave',trigger)
     },
     aEditedTrgSave({commit},trigger){
      commit('mEditedTrgSave',trigger)
     },
     aEditedTrgValueDelete({commit},del){
      commit('mEditedTrgValueDelete',del)
     },
     aDeleteTrgCard({commit},index){
      commit('mDeleteTrgCard',index)
     },
     aDeleteResponse({commit},index){
      commit('mDeleteResponse',index)
     },
     aDeleteResponseCard({commit}){
      commit('mDeleteResponseCard')
     },
     aActiveResponse({commit},index){
      commit('mActiveResponse',index)
     },
     aUpdateNewResponseCard({commit},value){
       console.log(value)
       commit('mUpdateNewResponseCard',value)
     },
     aNewcardType({commit}, value){
      console.log("action")
       commit('mNewcardType',value)
     },
     aNewResponseName({commit},value){
       commit('mNewResponseName',value)
     },
     aSaveResponse({commit},value){
        commit('mSaveResponse',value)
     },
     aSaveResponseCard({commit},value){
      commit('mSaveResponseCard',value)
     },
     aSaveQuickreply({commit},value){
       commit('mSaveQuickreply',value)
     },
     aActiveResponseCard({commit},index){
      commit('mActiveResponseCard',index)
     },
     aMoveResponseCardUp({commit},index){
      commit('mMoveResponseCardUp',index)
     },
     aMoveResponseCardDown({commit},index){
      commit('mMoveResponseCardDown',index)
     },
     aDeleteQuickReply({commit},index){
      commit('mDeleteQuickReply',index)
     },
     aFetchfbdata({commit}){
      commit('mFetchfbdata')
     },
     aFetchpagedata({commit},pageid){
       commit('mFetchpagedata', pageid)
     },
     aSelectedPage({commit},pageid){
       commit('mSelectedPage',pageid)
     },
     aFetchpmenu({commit},pageid){
       commit('mFetchpmenu',pageid)
     },
     afetchBTemplates({commit}){
       commit('mfetchBTemplates')
     },
     afetchresponses({commit}){
      commit('mfetchresponses')
    },
    afetchunknownkeywords({commit}){
      commit('mfetchunknownkeywords')
    },
     acreateBTemeplate({commit},message){
      commit('mcreateBTemeplate', message)
     },
     acreateResponse({commit},message){
      commit('mcreateResponse', message)
     },
     abcastmenuStatusChange({commit},status){
       commit('mbcastmenuStatusChange',status)
     },
     aresponsemenuStatusChange({commit},status){
      commit('mresponsemenuStatusChange',status)
    },
    arulemenuStatusChange({commit},status){
      commit('mrulemenuStatusChange',status)
    },
     acreatebcastTextMessage({commit},{index,message}){
      commit('mcreatebcastTextMessage',{index,message})
     },
     acreateresponseMessage({commit},{index,message}){
      commit('mcreateresponseMessage',{index,message})
     },
     abcastTemplateIndexChange({commit},{index}){
      commit('mbcastTemplateIndexChange',{index})
     },
     aresponseIndexChange({commit},{index}){
      commit('mresponseIndexChange',{index})
     },
     aupdateBTemeplate({commit},message){
      commit('mupdateBTemeplate',message)
     },
     aupdateResponse({commit},message){
      commit('mupdateResponse',message)
     },
     abcastdeleteTemplate({commit},{index}){
      commit('mbcastdeleteTemplate',{index})
     },
     aresponsedelete({commit},{index}){
      commit('mresponsedelete',{index})
     },
     aupdatebcastMessage({commit},{index}){
      commit('mupdatebcastMessage',{index})
     },
     aupdateresponseMessage({commit},{index}){
      commit('mupdateresponseMessage',{index})
     },
     ageneratemessengercode({commit},{refcode,size}){
      commit('mgeneratemessengercode',{refcode,size})
     },
     afetchrules({commit}){
       commit('mfetchrules')
     },
     acreaterule({commit},{rule}){
      commit('mcreaterule',{rule})
     },
     aruleindexChange({commit},index){
      commit('mruleindexChange',index)
     },
     aupdaterule({commit},{rule,index}){
      commit('mupdaterule',{rule,index})
     },
     aupdateMessageDelay({commit},{index,value}){
      commit('mupdateMessageDelay',{index,value})      
     },
     acreatequickreply({commit},{quickreply}){
      commit('mcreatequickreply',{quickreply})
     },
     adeletequickreply({commit},{qrindex}){
      commit('mdeletequickreply',{qrindex})
     },
     abcastcreatequickreply({commit},{quickreply}){
      commit('mbcastcreatequickreply',{quickreply})
     },
     abcastdeletequickreply({commit},{qrindex}){
      commit('mbcastdeletequickreply',{qrindex})
     },
     afetchassets({commit}){
      commit('mfetchassets')
     },
     acreateasset({commit},{asset}){
      commit('mcreateasset',{asset})
     },
     aupdatesnackbarstatus({commit},{status,update,timeout}){
       commit('mupdatesnackbarstatus',{status,update,timeout})
     },
     awelcomeresponse({commit},{pageid,access_token}){
     commit('mwelcomeresponse',{pageid,access_token})
     },
     adefaultresponse({commit},{pageid,access_token}){
      commit('mdefaultresponse',{pageid,access_token})
      },
     aupdateref({commit},{docId,ref}){
      commit('mupdateref',{docId,ref})
     },
     aresponseEditor({commit},{index, card}){
      commit('mresponseEditor',{index, card})
     },
     aSaveEditedresponseMessage({commit},{editedresponse}){
      commit('mSaveEditedresponseMessage',{editedresponse})
     },
     aSaveEditedquickreply({commit},{quickreply, qrindex}){
      commit('mSaveEditedquickreply',{quickreply, qrindex})
     },
     aupmoveresponseMessage({commit},{index}){
      commit('mupmoveresponseMessage',{index})
     },
     adownmoveresponseMessage({commit},{index}){
      commit('mdownmoveresponseMessage',{index})
     },
     aFetchUsers({commit},pageid){
       console.log(pageid)
     commit('mFetchUsers',pageid)
     },
     asaveUservars({commit},{setvars,docid}){
       commit('msaveUservars',{setvars,docid})
     },
     aresetgalleryelement({commit}){
      commit('mresetgalleryelement')
     },
     aaddNewGalleryCard({commit}){
      commit('maddNewGalleryCard')
     },
     afetchIntegrationDetails({commit},pageid){
       commit('mfetchIntegrationDetails',pageid)
     },
     aconnectSendgrid({commit},{pageid,text}){
       commit('mconnectSendgrid',{pageid,text})
     },
     adisconnectSendgrid({commit},pageid){
       commit('mdisconnectSendgrid',pageid)
     },
     adeleteunknownkeyword({commit},{index}){
       commit('mdeleteunknownkeyword',index)
     },
     asavecommentRule({commit},rule){
      commit('msavecommentRule',rule)
     },
     afetchcommmentRules({commit}){
       commit('mfetchcommmentRules')
     },
     adeletecommentRule({commit},{ruleid,ruleindex}){
       commit('mdeletecommentRule',{ruleid,ruleindex})
     },
     aupdatecommentRule({commit},{updateIndex,ruleid,rule}){
       commit('mupdatecommentRule',{updateIndex,ruleid,rule})
     }
   }
 })
